import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT, FRAGMENT_LONG_FORM_BUILDER_PROJECT } from './schema';

const QUERY = gql`
  query ProjectLongFormData($projectId: Int!, $draftIndex: ID) {
    project(id: $projectId) {
      id
      longFormBuilderProject(longFormBuilderDraftId: $draftIndex) {
        ...LongFormBuilderProject
      }
      longFormBuilderDrafts {
        ...LongFormBuilderDraft
      }
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_PROJECT}
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

export const queryProjectLongFormData = ({ projectId, draftIndex }, options) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
      draftIndex,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  }).then(({ data }) => getSingleProp(data));
};
